export const ShiftRecordBreakType = Object.freeze({
  Meal: 'meal',
  Other: 'other',
})
